// 活动管理api
import { ServerDistApi,ServerTaskApi,ServerProdApi } from '@/group-cloud/network/ServerBizApi';


export class DistributionApi {
    /* =========================客户任务管理=================================*/

    //任务配置列表
    public static queryTemplateList(data) {
        return ServerTaskApi.send('/activity/template/list', data);
    }
    //任务添加
    public static addTask(data) {
        return ServerTaskApi.send('/activity/template/add', data);
    }
    //任务更新
    public static editTask(data) {
        return ServerTaskApi.send('/activity/template/edit', data);
    }
    //任务详情
    public static queryTaskInfo(data) {
        return ServerTaskApi.get(`/activity/template/info?id=${data.id}`,{});
    }
    //任务推送列表
    public static queryPushList(data) {
        return ServerTaskApi.send(`/activity/info/list`,data);
    }
    //新增任务推送
    public static addTaskPush(data) {
        return ServerTaskApi.send('/activity/info/add', data);
    }
    //校验当前任务推送是否导入
    public static isImport(data) {
        return ServerTaskApi.send('/activity/join/info/verify/import', data);
    }
    //任务记录列表
    public static queryTaskRecords(data) {
        return ServerTaskApi.send('/activity/info/history/list', data);
    }
    //任务配置删除
    public static delTaskTemplate(data) {
        return ServerTaskApi.send(`/activity/template/del?id=${data.id}`, {});
    }
    //任务推送删除
    public static delTaskPush(data) {
        return ServerTaskApi.send(`/activity/info/del?id=${data.id}`, {});
    }
    //任务推送详情
    public static queryTaskPushInfo(data) {
        return ServerTaskApi.send(`/activity/info/info?id=${data.id}`, {});
    }
    //任务推送编辑
    public static editTaskPush(data) {
        return ServerTaskApi.send(`/activity/info/edit`, data);
    }
    //任务推送更新
    public static updateTaskPush(data) {
        return ServerTaskApi.send('/activity/info/updateStatus', data);
    }
    //任务记录详情更新
    public static queryTaskRecordInfo(data) {
        return ServerTaskApi.send('/activity/join/detail/info/list', data);
    }

    /*=========================客户任务管理=================================*/
    //活动入口查询
    public static queryEntranceList(data) {
        return ServerDistApi.send('/activityEntrance/queryEntranceList', data);
    }
    //活动入口详情查询
    public static queryEntranceDetail(data) {
        return ServerDistApi.get('/activityEntrance/queryEntrance', data);
    }

    public static queryEntranceIsDelete(data) {
        return ServerDistApi.get('/activityEntrance/queryEntranceIsDelete', data);
    }

    //活动入口插入
    public static saveEntrance(data) {
        return ServerDistApi.send('/activityEntrance/saveEntrance', data);
    }

    //活动入口更新
    public static updateEntrance(data) {
        return ServerDistApi.send('/activityEntrance/updateEntrance', data);
    }

    //客户活动查询
    public static queryActivityList(data) {
        return ServerDistApi.send('/customerActivity/queryActivityList', data);
    }

    //客户活动插入
    public static saveActivity(data) {
        return ServerDistApi.send('/customerActivity/saveActivity', data);
    }

    //客户活动更新接口
    public static updateActivity(data) {
        return ServerDistApi.send('/customerActivity/updateActivity', data);
    }
    //活动配置插入
    public static insertActivityConfig(data) {
        return ServerDistApi.send('/activityConfig/insert', data);
    }
    //活动配置分页查询
    public static activityConfigList(data) {
        return ServerDistApi.send('/activityConfig/pageInfo', data);
    }
    //活动配置详情接口
    public static getActivityConfig(data) {
        return ServerDistApi.get('/activityConfig/get', data);
    }
    //活动配置更新接口
    public static updateActivityConfig(data) {
        return ServerDistApi.send('/activityConfig/update', data);
    }
    //商品查询
    public static queryGoods(data) {
        return ServerDistApi.get('/activityConfig/queryGoods', data);
    }
    // 删除活动配置接口
    public static deleteActive(data) {
        return ServerDistApi.get('/activityConfig/delete', data);
    }
    //查看表单接口
    public static queryActivityDetail(data) {
        return ServerDistApi.get('/userActivity/queryActivityDetail', data);
    }
    //活动表单下载接口
    public static getDetailExcel(data) {
        return ServerDistApi.get('/userActivity/getDetailExcel', { ...data, responseType: 'blob' });
    }
    public static async getDetailExcel_2(data) {
        return await ServerDistApi.get('/userActivity/getDetailExcel', data, {responseType: 'blob' });
    }
     //批量输入门店编号
     public static querystoreIds(data) {
        return ServerProdApi.send('/user/find/getClientOrStore', data);
    }


}

// 门店售卖
export class storeSaleApi {
    //商品查询
    public static getList(data) {
        return ServerDistApi.get('/scanPay/getSaleSkuList', data);
    }
    public static exportData(data) {
        return ServerDistApi.get('/scanPay/exportSaleDetailExcel', data);
    }
    //查询买家类型
    public static async searchStore(data) {
      let uri = '/customer/man/search/store';
      return await ServerDistApi.send(uri, data);
    }
}


